import React from 'react';

import styles from './GeoElementsList.less';

export class GeoElementsList extends React.Component {
  render() {
    const { items, headline } = this.props;

    return (
      <div className={`grid-item one-whole padding-bottom-xxl ${styles.main}`}>
        <div className={`grid pb-list ${styles.inner}`}>
          <div className="grid-item one-whole font-center headline-text padding-bottom-l">
            <p className={`font-regular font-h3 font-bold ${styles.headline}`}>{headline}</p>
          </div>
          <div className="grid geo-element-list">
            {items &&
              items.map((item) => (
                <div
                  className="grid-item geo-element-list-item-cosma desk-one-third lap-one-half palm-one-whole"
                  key={item.name}
                >
                  <span>
                    <a href={item.key} id={item.name}>
                      {item.name}
                    </a>
                  </span>
                </div>
              ))}
          </div>
        </div>
      </div>
    );
  }
}

export default GeoElementsList;
